// ANGULAR
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { MetaReducer, StoreModule } from '@ngrx/store';

// CUSTOM MODULES
import { GlobalStoreModule } from './global/global-store.module';
import { MasterStoreModule } from './master/master-store.module';
import { AuthStoreModule } from './modules/auth/auth-store.module';
import { BusinessStoreModule } from './modules/business/business-store.module';
import { ClientStoreModule } from './modules/client/client-store.module';
import { DashboardStoreModule } from './modules/dashboard/dashboard-store.module';
import { EmployeeStoreModule } from './modules/employee/employee-store.module';
import { MasterBusinessStoreModule } from './modules/master-business/master-business-store.module';
import { NewsFeedStoreModule } from './modules/news-feed/news-feed-store.module';
import { RequestStoreModule } from './modules/request/request-store.module';
import { ScheduleStoreModule } from './modules/schedule/schedule-store.module';
import { TaskStoreModule } from './modules/task/task-store.module';
import { UserStoreModule } from './modules/user/user-store.module';

// SERVICES
import { ApiConfigService } from './core/services/api-config/api-config.service';
import { TokenStorageService } from './core/services/token-storage/token-storage.service';

// STORE
import { CustomSerializer } from './router/custom-serializer';
import { FormStoreModule } from './modules/form/form-store.module';
import { TimeSheetStoreModule } from './modules/timesheet/timesheet-store.module';

const metaReducers: Array<MetaReducer<any, any>> = [];

/**
 * This module is for configure all ngrx related stuff.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) configure ngrx store in ng module
 */
@NgModule({
  declarations: [],
  imports: [

    /********************NGRX MODULES*******************/
    StoreModule.forRoot({ router: routerReducer }, { metaReducers }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    /********************NGRX MODULES*******************/

    /** IMPORT CUSTOM MODULE HERE. */
    GlobalStoreModule,
    MasterStoreModule,
    AuthStoreModule,
    BusinessStoreModule,
    MasterBusinessStoreModule,
    ClientStoreModule,
    EmployeeStoreModule,
    TaskStoreModule,
    UserStoreModule,
    RequestStoreModule,
    NewsFeedStoreModule,
    ScheduleStoreModule,
    DashboardStoreModule,
    FormStoreModule,
    TimeSheetStoreModule,
  ],
  providers: [
    TokenStorageService,
    ApiConfigService,
    { provide: RouterStateSerializer, useClass: CustomSerializer },
  ],
})
export class StateModule { }
